import React from "react";
import PublicLegalPage from "./PublicLegalPage";

/**
 * PublicDatenschutz — anonym zugänglich (für Register-Seite & öffentliche Links).
 * Inhalt: identisch zu /datenschutz (eingeloggt), nur ohne Auth-Layout.
 */
export default function PublicDatenschutz() {
  return (
    <PublicLegalPage
      title="Datenschutzerklärung"
      subtitle="DSGVO-konform · alle Daten in der EU"
      lastUpdated="22. April 2026"
      testid="page-public-datenschutz"
    >
      <h2>1. Verantwortliche Stelle</h2>
      <p>
        <strong>Easy Gutachter GmbH</strong>, Im Mediapark 8, 50670 Köln, Deutschland.<br />
        Datenschutz-Kontakt: <a href="mailto:datenschutz@easy-gutachter.de">datenschutz@easy-gutachter.de</a>
      </p>

      <h2>2. Welche Daten verarbeiten wir?</h2>
      <ul>
        <li><strong>Account-Daten</strong>: Name, E-Mail, Telefonnummer, Adresse, Bankverbindung, USt-IdNr.</li>
        <li><strong>Akten-Inhalte</strong>: Halterdaten, Fahrzeugdaten, Fotos, Unterschriften, Schadensbeschreibungen.</li>
        <li><strong>Technische Daten</strong>: IP-Adresse, Browser-Informationen (anonymisiert nach 30 Tagen).</li>
        <li><strong>Nutzungsdaten</strong>: Logins, geöffnete Akten, exportierte PDFs (zur Sicherheits-Auditierung).</li>
      </ul>

      <h2>3. Rechtsgrundlagen</h2>
      <p>
        Die Verarbeitung erfolgt auf Basis von <strong>Art. 6 Abs. 1 lit. b DSGVO</strong> (Vertragserfüllung),
        <strong> Art. 6 Abs. 1 lit. c DSGVO</strong> (rechtliche Verpflichtung — z. B. Aufbewahrungspflichten)
        und <strong>Art. 6 Abs. 1 lit. f DSGVO</strong> (berechtigtes Interesse — z. B. Sicherheits-Logs).
      </p>

      <h2>4. Wo werden Daten gespeichert?</h2>
      <p>
        Alle personenbezogenen Daten werden ausschließlich auf Servern <strong>innerhalb der EU</strong>
        (Frankfurt am Main) verarbeitet und gespeichert. Es findet keine Datenübermittlung in Drittstaaten statt.
      </p>

      <h2>5. Drittdienste & Auftragsverarbeiter</h2>
      <ul>
        <li><strong>Stripe Payments Europe Ltd.</strong> — Zahlungsabwicklung (Rechnungsdaten, Lastschrift-IBAN).</li>
        <li><strong>Hetzner Online GmbH</strong> — Server-Hosting (Frankfurt).</li>
        <li><strong>DAT (Deutsche Automobil Treuhand)</strong> — Fahrzeugbewertung (Übermittlung VIN + Kennzeichen, nur bei aktivem Lookup).</li>
        <li><strong>EasyExpert24</strong> — Versicherungsauskunft (GDV-Lookup; Übermittlung Kennzeichen + Schadendatum).</li>
      </ul>
      <p>
        Mit allen Auftragsverarbeitern bestehen DSGVO-konforme Verträge (Art. 28 DSGVO).
      </p>

      <h2>6. Ihre Rechte</h2>
      <ul>
        <li><strong>Auskunft</strong> (Art. 15 DSGVO)</li>
        <li><strong>Berichtigung</strong> (Art. 16 DSGVO)</li>
        <li><strong>Löschung</strong> (Art. 17 DSGVO) — sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</li>
        <li><strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO)</li>
        <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
        <li><strong>Widerspruch</strong> (Art. 21 DSGVO)</li>
        <li><strong>Beschwerde</strong> bei der zuständigen Aufsichtsbehörde (LDI NRW, Düsseldorf).</li>
      </ul>

      <h2>7. Aufbewahrungsdauer</h2>
      <ul>
        <li>Account-Daten: bis zur Kündigung + 30 Tage Karenzzeit (Daten-Export möglich).</li>
        <li>Akten-Inhalte: 10 Jahre (steuerliche und versicherungsrechtliche Aufbewahrungspflicht).</li>
        <li>Sicherheits-Logs: 30 Tage.</li>
      </ul>

      <h2>8. Cookies & Tracking</h2>
      <p>
        Wir setzen ausschließlich <strong>technisch notwendige Cookies</strong> für Authentifizierung
        und Session-Management ein. Kein Tracking, keine Marketing-Cookies, kein Cookie-Banner erforderlich.
      </p>
    </PublicLegalPage>
  );
}
